<template>
  <span class="books__free-icon">Free Book</span>
</template>
